import { render, staticRenderFns } from "./ScreenVideo.vue?vue&type=template&id=6dc1537e&scoped=true&"
import script from "./ScreenVideo.vue?vue&type=script&lang=ts&"
export * from "./ScreenVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenVideo.vue?vue&type=style&index=0&id=6dc1537e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1537e",
  null
  
)

export default component.exports